<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close" (click)="close.emit(1)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <label class="modal-title">Configure Application Parameters</label>
  </div>
  <div class="modal-body">
    <form class="form form-add form-horizontal" [formGroup]="paramsForm" (ngSubmit)="submitParams()">
      <div *ngFor='let parameter of parameters; let last = last' [class.button-separation]="last" class="form-group"
        [ngClass]="{'has-error':!paramsForm.controls[parameter.parameterId].valid && isSubmitted}">
        <label class="col-md-5" for="{{parameter.definition.name}}">{{parameter.definition.label}}</label>
        <div class="col-md-7" [ngSwitch]="parameter.definition.type">
          <input
            [readonly]="isReadonly(parameter.parameterId, parameter.definition.parentId && !paramsForm.controls[parameter.definition.parentId]?.value)"
            *ngSwitchCase="'String' || 'Integer'" maxlength="{{parameter.definition.maxLength}}" type="text"
            class="inputStyle textInput form-control" name="{{parameter.definition.name}}"
            formControlName="{{parameter.parameterId}}" />
          <input
            [readonly]="isReadonly(parameter.parameterId, parameter.definition.parentId && !paramsForm.controls[parameter.definition.parentId]?.value)"
            *ngSwitchCase="'Integer'" min="{{parameter.definition.minValue}}" max="{{parameter.definition.maxValue}}"
            type="number" class="inputStyle textInput form-control" name="{{parameter.definition.name}}"
            formControlName="{{parameter.parameterId}}" />
          <input
            [readonly]="isReadonly(parameter.parameterId, parameter.definition.parentId && !paramsForm.controls[parameter.definition.parentId]?.value)"
            *ngSwitchCase="'Float'" min="{{parameter.definition.minValue}}" max="{{parameter.definition.maxValue}}"
            type="number" class="inputStyle textInput form-control" name="{{parameter.definition.name}}"
            formControlName="{{parameter.parameterId}}" />
          <select *ngSwitchCase="'Enum'" class="inputStyle dropdownInput iconInput arrow-bg"
            name="{{parameter.definition.name}}" formControlName="{{parameter.parameterId}}">
            <option *ngFor='let option of parameter.definition.options?.split(",")' [value]='option'>{{option}}</option>
          </select>
          <input *ngSwitchCase="'Boolean'" type="checkbox" class="checkboxInput" name="{{parameter.definition.name}}"
            formControlName="{{parameter.parameterId}}" />
        </div>
        <div *ngIf="paramsForm.controls[parameter.parameterId].hasError('required') && isSubmitted"
          class="validation-msg">You must enter {{parameter.label}}.</div>
        <div *ngIf="paramsForm.controls[parameter.parameterId].hasError('maxLength') && isSubmitted"
          class="validation-msg">Maximum characters are [{{parameter.maxLength}}]</div>
        <div *ngIf="paramsForm.controls[parameter.parameterId].hasError('min') && isSubmitted" class="validation-msg">
          You must enter value between [{{parameter.definition.minValue}}] and [{{parameter.definition.maxValue}}].
        </div>
        <div *ngIf="paramsForm.controls[parameter.parameterId].hasError('max') && isSubmitted" class="validation-msg">
          You must enter value between [{{parameter.definition.minValue}}] and [{{parameter.definition.maxValue}}].
        </div>
        <div *ngIf="paramsForm.controls[parameter.parameterId].hasError('pattern') && isSubmitted"
          class="validation-msg">Format is not valid.</div>
      </div>
      <div class="row">
        <div class="col-md-3 pull-left">
          <button type="button" class="btn btn-block btn-active" (click)="goBack.emit(1)">Back</button>
        </div>
        <div class="col-md-3 pull-right">
          <button class="btn btn-block btn-active">Submit</button>
        </div>
      </div>
    </form>
  </div>
</div>